/* ============
 * The initial state of the resolve module.
 * ============
 */
export default {
  loading: false,
  resolveActionsList: [],
  error: null
};
